import { IEnvironment } from 'sc-common/core/models/environment';

export const environment: IEnvironment = {
    production: true,
    project: 'editing-tool',
    portal: 'scientific',
    apiUrl: 'https://api-scientific-net.stp.net',
    publicBaseUrl: 'https://www.scientific-net.stp.net',
    mainBaseUrl: 'https://main.scientific-net.stp.net',
    internalBaseUrl: 'https://admin-scientific-net.stp.net',
    identityProviderUrl: 'https://idp-scientific-net.stp.net',
    editingToolBaseUrl: 'https://et-scientific-net.stp.net',
    contentManagerBaseUrl: 'https://cm-scientific-net.stp.net'
};
